import { useTranslation } from "react-i18next";
import { Container, Box, Typography } from "@mui/material";

const DeliveryPolicy = () => {
  const { t, i18n } = useTranslation();

  const policyItems = [
    {
      id: "failure_to_collect_vehicle",
      heading: t(
        "failure_to_collect_vehicle_heading",
        "Failure to Collect Vehicle"
      ),
      descriptionKey: "failure_to_collect_vehicle",
    },
    {
      id: "missing_documents",
      heading: t("missing_documents_heading", "Missing Required Documents"),
      descriptionKey: "missing_documents",
    },
    {
      id: "authorization_issue",
      heading: t("authorization_issue_heading", "Authorization Issues"),
      descriptionKey: "authorization_issue",
    },
    {
      id: "refund_processing",
      heading: t("refund_processing_heading", "Refund Processing Timeline"),
      descriptionKey: "refund_processing",
    },
    {
      id: "security_deposit",
      heading: t("security_deposit_heading", "Security Deposit Terms"),
      descriptionKey: "security_deposit",
    },
    {
      id: "free_cancellation_policy",
      heading: t(
        "free_cancellation_policy_heading",
        "Free Cancellation Policy"
      ),
      descriptionKey: "free_cancellation_policy",
    },
    {
      id: "late_cancellation_fee",
      heading: t("late_cancellation_fee_heading", "Late Cancellation Fee"),
      descriptionKey: "late_cancellation_fee",
    },
    {
      id: "grace_period",
      heading: t("grace_period_heading", "Vehicle Return Grace Period"),
      descriptionKey: "grace_period",
    },
  ];
  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        {/* Page Title */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              color: "#520A76",
              mb: 2,
            }}
          >
            {t("cancellation_delivery_policy")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              fontSize: 14,
            }}
          >
            {t(
              "policy_description",
              "Please review our comprehensive policy for vehicle cancellations, pickups, and returns."
            )}
          </Typography>
        </Box>

        {/* Policy Items List */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {policyItems.map((item) => (
            <Box key={item.id}>
              {/* Heading */}
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#520A76",
                  mb: 1.5,
                  fontSize:18
                }}
              >
                {item.heading}
              </Typography>

              {/* Description */}
              <Typography
                variant="body2"
                sx={{
                  color: "#555",
                  lineHeight: 1.8,
                  fontSize: 14,
                }}
              >
                {t(item.descriptionKey)}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default DeliveryPolicy;
